import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trophy, Loader2, BadgeCheck, Clock3, XCircle } from "lucide-react";
import { authAxios } from "@/context/AuthContext";

const STATUS_STYLES = {
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: BadgeCheck },
  pending: { label: "Under review", cls: "bg-amber-50 text-amber-700 border-amber-200", icon: Clock3 },
  rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200", icon: XCircle },
};

export const DashboardSignups = () => {
  const [items, setItems] = useState([]);
  const [approvedCount, setApprovedCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authAxios.get("/user/affiliate-signups")
      .then((r) => { setItems(r.data.submissions); setApprovedCount(r.data.approved_count); })
      .catch((err) => { console.error("signups fetch failed:", err); toast.error("Could not load your signups"); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section data-testid="dashboard-signups-section" className="bg-white border border-slate-200 rounded-xl p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-heading font-semibold text-lg">My affiliate signups</h3>
        <div data-testid="signups-approved-count" className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 border border-emerald-200 px-3 py-1 rounded-full text-xs font-semibold">
          <Trophy className="w-3.5 h-3.5" /> {approvedCount} approved
        </div>
      </div>
      <p className="text-sm text-slate-500 mb-5">Every approved signup counts toward the monthly leaderboard. Prizes ship on the 1st.</p>

      {loading ? (
        <div className="py-6 text-slate-400 flex items-center gap-2 text-sm"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
      ) : items.length === 0 ? (
        <p className="text-sm text-slate-400 italic py-4">
          No signups submitted yet. When you join an affiliate program, click &ldquo;I signed up&rdquo; on any program card to log it.
        </p>
      ) : (
        <ul className="divide-y divide-slate-100">
          {items.map((s) => {
            const style = STATUS_STYLES[s.status] || STATUS_STYLES.pending;
            const Icon = style.icon;
            return (
              <li key={s.id} data-testid={`signup-row-${s.id}`} className="py-3 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-slate-900 truncate">{s.program_name}</p>
                  <p className="text-xs text-slate-500 truncate">
                    {new Date(s.submitted_at).toLocaleDateString()}
                    {s.admin_note && <span className="ml-2 italic">· &ldquo;{s.admin_note}&rdquo;</span>}
                  </p>
                </div>
                <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-semibold border ${style.cls}`}>
                  <Icon className="w-3 h-3" /> {style.label}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
